module.exports = __webpack_public_path__ + "static/printed-labels-341a9ace7188c958b821205183977366.png";